"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterRoutesByScreenType = void 0;

var _factory = require("../factory");

var filterRoutesByScreenType = function filterRoutesByScreenType() {
  var screenType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _factory.factory.SCREEN_TYPE.DESKTOP;
  return function () {
    var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return routes.filter(function (route) {
      return Array.isArray(route.screenTypes) && route.screenTypes.includes(screenType);
    });
  };
};

exports.filterRoutesByScreenType = filterRoutesByScreenType;